import { PARAM_TYPE_MAP, PARAM_TYPE_VALUE_MAP } from "../../utils/lists";
import { BaseWebComponent } from "../base-components/base-web-component";

export class BonusViewParameters extends BaseWebComponent {
    static override webComponentName: string = "bonus-view-parameters";
    protected override _templateId: string = "bonus-view-parameters";
    protected parameters!: any[];
    constructor() {
        super();
    }
    private getTypeDisplayName(typeValue: string): string {
        const typeMap = PARAM_TYPE_MAP;
        return typeMap[typeValue] || typeValue;
    }
    private getTypeValueDisplayName(typeValue: string): string {
        const typeValueMap = PARAM_TYPE_VALUE_MAP;
        return typeValueMap[typeValue] || typeValue;
    }

    protected buildRenderingData(): Record<string, any> {
        const baseData = super.buildRenderingData();

        return {
            ...baseData,
            getTypeDisplayName: this.getTypeDisplayName.bind(this),
            getTypeValueDisplayName: this.getTypeValueDisplayName.bind(this),
            parameters: this.parameters
        };
    }
    protected render(): void {
        
        if (!this.parameters) {
            const scriptTag = this.querySelector('script[type="application/json"]');
            if (scriptTag) {
                try {
                    this.parameters = JSON.parse(scriptTag.textContent.trim());
                } catch (error) {
                    console.error("Error parsing parameters JSON:", error);
                    this.parameters = [];
                }
                this.innerHTML = ''; // Clear the script tag content after parsing
                super.render();
            }
            else {
                console.log(this.innerHTML);
                return ;
            }
        }
        else {
            this.innerHTML = 'i parametri c\'erano';
        }
    }
}